import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTelegram = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 25 25",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12.5 2.5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19Zm4.4 6.46c-.14 1.5-.76 5.15-1.08 6.83-.13.72-.4.95-.65.98-.55.05-.97-.37-1.5-.72-.84-.55-1.31-.89-2.12-1.42-.94-.62-.33-.96.2-1.52.14-.14 2.57-2.35 2.62-2.55 0-.03.01-.12-.04-.17-.06-.05-.14-.03-.2-.02-.08.02-1.42.9-4 2.65a1.8 1.8 0 0 1-1.04.38c-.34 0-.99-.2-1.47-.35-.6-.2-1.07-.3-1.03-.62.02-.18.26-.35.7-.53l5.54-2.39c2.64-1.1 3.2-1.28 3.55-1.29.45 0 .56.36.52.74Z",
		clipRule: "evenodd"
	})
});
export default SvgTelegram;
